// extracted by mini-css-extract-plugin
export default {"payment":"styles_payment__ccUiG","users":"styles_users__C5cFt","avatar":"styles_avatar__8Rljk","nextButton":"styles_nextButton__PPNmq"};